<template>
  <b-container
    fluid="md"
    class="square-payment-error"
  >
    <b-row>
      <b-col class="payment-error-header">
        <div class="title">
          <font-awesome-icon
            icon="triangle-exclamation"
            class="icon error-icon"
            size="2x"
            fixed-width
            color="red"
          />
          <span class="h3 pr-4">
            Payment Processing Error
          </span>
        </div>
        <div class="error-message">
          {{ errorMessage }}
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="transaction-details">
          <h3>Transaction Details</h3>
          <div>
            <span class="label">Date:</span>
            <span
              class="value"
              data-cy="payment-txndate"
            >{{ txndate | longdate }}</span>
          </div>
          <div>
            <span class="label">Txn </span>
            <span
              class="value"
              data-cy="payment-txnid"
            >{{ txnid }}</span>
          </div>
          <div>
            <span class="label">Amount:</span>
            <span class="value">{{ txnAmount | formatCurrency(currency) }}</span>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="errorMessage">
      <b-col>
        <div class="error-details">
          <h3>Error Details</h3>
          <div v-if="errorType">
            <span class="label">Error Type</span>
            <span
              class="value"
              data-cy="error-type"
            >{{ errorType }}</span>
          </div>
          <div v-if="errorCategory">
            <span class="label">Category</span>
            <span
              class="value"
              data-cy="error-message"
            >{{ errorCategory }}</span>
          </div>
          <div v-if="errorDetails">
            <span class="label">Details</span>
            <span
              class="value"
              data-cy="error-details"
            >{{ errorDetails }}</span>
          </div>
        </div>
      </b-col>
    </b-row>
    <square-response-debug-wrapper
      v-if="debug"
      :debug-data="debugData"
    />
  </b-container>
</template>

<script>
import CommonTxnFields from './common-txn-fields'
import DebugWrapper from './debug.vue'

export default {
  name: 'square-payments-error',
  components: {
    'square-response-debug-wrapper': DebugWrapper
  },
  mixins: [
    CommonTxnFields
  ],
  props: {
    debug: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      showDebug: false
    }
  },
  computed: {
    currency: function() {
      return this.$store.getters['square/currency']
    },
    errorType: function() {
      try {
        return this.paymentResponse.error.type
      }
      catch (err) {
        return false
      }
    },
    errorCategory: function() {
      try {
        return this.paymentResponse.error.category
      }
      catch (err) {
        return false
      }
    },
    errorMessage: function() {
      try {
        return this.paymentResponse.error.message
      }
      catch (err) {
        return false
      }
    },
    errorDetails: function() {
      try {
        return this.paymentResponse.error.details
      }
      catch (err) {
        return false
      }
    }

  }
}
</script>

<style lang="scss" scoped>
  .square-payment-error {
    .payment-error-header {
      .title {
        font-size: 2.2rem;
        margin-bottom: 1rem;
        display: flex;
        align-items: center;
      }
      .message {
        font-size: 1rem;
        margin-bottom: 1rem;
      }
    }
    .label {
      display: inline-block;
      width: 200px;
    }
    .success-icon {
      color: green;
    }
  }
</style>
